import * as React from 'react';
import * as Images from 'pos/Images';
import { PrintPreviewDTO, InvoiceDTO, PrintTemplateType } from 'core/api';
import { Col, Cols, TemplatePrintPreview } from 'core/ui';
import { PrintFacade } from 'pos/facades';
import { Command } from 'pos/common';
import { Modal } from 'core/ui-next/modal';
import { ActionButtonDefinition, PosStatelessScreenClassComponent, ScreenSize } from 'pos/ui';
import { Toaster } from 'core/ui-next';

type Props = {
	preview: PrintPreviewDTO,
	title: string;
	actionImage: string | SvgIcon;
} & Modal.Actions<void>;

class ShowPreview extends PosStatelessScreenClassComponent<Props> {


	protected getScreenId(): string {
		return 'SHOW_INVOICE_PREVIEW';
	}

	protected getTitle(): string {
		return this.props.title;
	}

	protected getImage(): string | SvgIcon {
		return Images.ViewTicket;
	}

	protected getSize(): ScreenSize {
		return 'medium';
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			{ title: this.props.title, image: this.props.actionImage, action: async () => this.close() }
		];
	}

	protected getContent(): React.ReactNode {

		return <Cols style={{ margin: 'auto', color: 'white' }}>
			<Col width='*'>
				<TemplatePrintPreview preview={this.props.preview} />
			</Col>
		</Cols>;
	}

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}

	protected useKeypad() {
		return false;
	}
}

declare global {
	interface CommandType {
		showInvoicePreview: (invoice: InvoiceDTO, title: string, actionImage: string | SvgIcon) => Promise<Result>
	}
}

Command.register('showInvoicePreview', 'NO_PRECONDITION', async (invoice: InvoiceDTO, title: string, actionImage: string | SvgIcon): Promise<Result> => {

	// El preview puede lanzar una excepción de dominio si no se han configurado correctamente los templates de TicketBAI o Verifactu
	const preview = await PrintFacade.getInvoicePreviews(invoice.Id)
		.then(previews => previews[0])
		.catch(err => {
			Toaster.error(err.message);
			return { EscPosNumberOfColumns: 42, EscPosPreview: '', RdlBase64Images: [], TemplateType: PrintTemplateType.EscPos } satisfies PrintPreviewDTO;
		});
	return Modal.show(ShowPreview, { preview, title: title, actionImage: actionImage });
});
